// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1NiG-","inner":"Form_inner__2s4i_","range":"Form_range__cAQdf","name":"Form_name__1gVCe","actions":"Form_actions__22lH4"};